export const getOrders = `query Orders($page:Int, $rows:Int){
    allOrders(page:$page, rows:$rows){
      _id
      orderId
      deliveryAddress{
        latitude
        longitude
        deliveryAddress
        details
        label
        apartment
        buildingName
        entryCode
        dropoffOption
      }
      deliveryCharges
      serviceFee
      orderAmount
      paidAmount
      paymentMethod paymentLabel cardBrand cardLast4
      qorTransactionId
      restaurant{
        _id timezone
        name
        address
      }
      user{
        _id
        name
        email
        phone
      }
      items{
        _id
        title
        description
        quantity
        variation{
          _id
          title
          price
          discounted
        }
        addons{
          _id
          title
          description
          additionalCost
          quantityMinimum
          quantityMaximum
          options{
            _id
            title
            price
            quantity
            addons{ title additionalCost options{ title price quantity } }
          }
        }
        specialInstructions
        isActive
      }
      reason
      paymentStatus
      orderStatus
      preparedAt
      isPickedUp
      orderType
      orderSource
      isSelfDelivery
      isCatering
      deliveryProofImage
      pickupReceiptImage
      isActive
      createdAt
      tipping
      taxationAmount
      instructions
      review{
        _id
        rating
        description
      }
      rider{
        _id
        name
        username
        phone
        pictureUrl
        driverType
        available
      }
      promotion {
        _id
        code
        discountAmount
      }
      # The rest of what the Orders cards and detail modal read. Without these
      # the super admin's finished orders had no refund state (so the Refunded
      # tab was always empty), no First Delivery driver and no proof photo.
      orderDate
      blackCardDiscount
      walletAmountUsed
      serverTip
      driverTip
      supportTicketId
      supportTicketStatus
      refundedItems
      refundedAmount
      totalRefunded
      firstDeliveryOrderId
      fdDriverName
      fdDriverPhone
      fdDriverPhoto
      fdDriverTransport
      fdPickupEta
      fdDropoffEta
      fdDropoffPhoto
      fdTrackerLink
      fdDspTrackerLink
      assignedStaff {
        _id
        firstName
        lastName
        role
      }
    }
  }`

export const getOrderById = `query GetOrderById($id: Int!) {
  getOrderById(id: $id) {
    _id orderId deliveryCharges orderAmount paidAmount paymentMethod paymentLabel cardBrand cardLast4
    reason paymentStatus orderStatus preparedAt isPickedUp isSelfDelivery deliveryProofImage pickupReceiptImage isActive
    createdAt tipping taxationAmount instructions
    deliveryAddress { latitude longitude deliveryAddress details label apartment buildingName entryCode dropoffOption }
    restaurant { _id timezone name address }
    user { _id name email phone }
    items {
      _id title description quantity specialInstructions isActive
      variation { _id title price discounted }
      addons { _id title description additionalCost quantityMinimum quantityMaximum options { _id title price quantity addons { title additionalCost options { title price quantity } } } }
    }
    review { _id rating description }
    rider { _id name username available }
    promotion { _id code discountAmount }
  }
}`

export const reviews = `query Reviews($restaurant:ID!){
    reviews(restaurant:$restaurant){
      _id
      rating
      description
      createdAt
      user{
        _id
        name
        email
      }
      order{
        _id
        orderId
      }
    }
  }
`

export const getOrdersByDateRange = `query GetOrdersByDateRange($startingDate: String!, $endingDate: String!, $restaurant: String!) {
    getOrdersByDateRange(startingDate: $startingDate, endingDate: $endingDate, restaurant: $restaurant) {
      totalAmountCashOnDelivery
      countCashOnDeliveryOrders
    }
    
  }
`

export const getOrdersByRestaurant = `query ordersByRestId($restaurant:ID!,$page:Int,$rows:Int,$search:String){
    ordersByRestId(restaurant:$restaurant,page:$page,rows:$rows,search:$search){
      _id
      orderId
      restaurant{
        _id timezone
        name
        image
        address
        location{coordinates}
        deliveryTime
        preparationTime
      }
      deliveryAddress{
        latitude
        longitude
        deliveryAddress
        details
        label
        apartment
        buildingName
        entryCode
        dropoffOption
      }
      items{
        _id
        title
        description
        image
        quantity
        variation{
          _id
          title
          price
          discounted
        }
        addons{
          _id
          options{
            _id
            title
            price
            quantity
            addons{ title additionalCost options{ title price quantity } }
          }
          description
          title
          additionalCost
          quantityMinimum
          quantityMaximum
        }
        specialInstructions
        isActive
      }
      user{
        _id
        name
        phone
        email
      }
      paymentMethod paymentLabel cardBrand cardLast4
      paidAmount
      orderAmount
      orderStatus
      preparedAt
      isPickedUp
      orderSource
      orderType
      isSelfDelivery
      isCatering
      deliveryProofImage
      pickupReceiptImage
      paymentStatus
      reason
      isActive
      createdAt
      deliveryCharges
      serviceFee
      tipping
      taxationAmount
      expectedTime
      preparationTime
      instructions
      firstDeliveryOrderId
      fdDriverName
      fdDriverPhone
      fdDriverPhoto
      fdDriverTransport
      fdPickupEta
      fdDropoffEta
      fdDropoffPhoto
      fdTrackerLink
      fdDspTrackerLink
      supportTicketId
      supportTicketStatus
      refundedItems
      refundedAmount
      totalRefunded
      acceptedAt
      assignedAt
      pickedAt
      deliveredAt
      cancelledAt
      rider{
        _id
        name
        username
        phone
        pictureUrl
        driverType
        available
        location { coordinates }
        zone { _id title }
      }
      promotion {
        _id
        code
        discountAmount
      }
      serverTip
      driverTip
      blackCardDiscount
      walletAmountUsed
      blackCardMember
      assignedStaff { _id firstName lastName role }
    }
  }`

export const getDashboardTotal = `query GetDashboardTotal($startingDate: String, $endingDate: String,$restaurant:ID){
    getDashboardTotal(startingDate: $startingDate, endingDate: $endingDate,restaurant:$restaurant){
      totalOrders
      totalSales
      totalCardOrders
    }
  }`
export const getDashboardSales = `query GetDashboardSales($startingDate: String, $endingDate: String,$restaurant:ID){
    getDashboardSales(startingDate: $startingDate, endingDate: $endingDate,restaurant:$restaurant){
      orders{
        day
        amount
      }
    }
  }`
export const getDashboardOrders = `query GetDashboardOrders($startingDate: String, $endingDate: String,$restaurant:ID){
    getDashboardOrders(startingDate: $startingDate, endingDate: $endingDate,restaurant:$restaurant){
      orders{
        day
        count
      }
    }
  }`

// Sales and payout report — rendered as the backend's sections, so the admin,
// the restaurant app and the emailed report read the same.
export const restaurantReport = `query RestaurantReport($restaurantId: ID!, $from: String!, $to: String!){
    restaurantReport(restaurantId: $restaurantId, from: $from, to: $to){
      restaurantId restaurantName timezone from to
      summary { orders foodSales customersPaid commission yourShare rmfSends avgOrder uniqueCustomers }
      sections { key title subtitle rows { label hint amount count kind } }
      days { date orders foodSales customersPaid commission yourShare rmfSends tips }
    }
  }`

export const restaurantDashboard = `query RestaurantDashboard($restaurantId: ID!, $from: String!, $to: String!, $compare: String, $channel: String){
    restaurantDashboard(restaurantId: $restaurantId, from: $from, to: $to, compare: $compare, channel: $channel){
      restaurantId
      restaurantName
      restaurantSlug
      timezone
      isOpen
      generatedAt
      compare
      channel
      current { from to grossSales orders avgOrderValue onlineOrders cancelledOrders }
      previous { from to grossSales orders avgOrderValue onlineOrders cancelledOrders }
      days { date prevDate weekday sales orders onlineOrders cancelledOrders prevSales prevOrders closed }
      weekday { day sales orders prevSales prevOrders }
      hourly { hour sales orders prevSales prevOrders }
      breakdown {
        channels { key label sales orders share daily }
        fulfillment { key label sales orders share daily }
        payment { key label sales orders share daily }
      }
      topItems { name quantity revenue share }
      recentOrders { id number channel placedAt total status }
      ratings { average count latestText latestRating latestAt }
    }
  }`

export const getDashboardData = `query GetDashboardData($startingDate: String, $endingDate: String){
    getDashboardData(startingDate: $startingDate, endingDate: $endingDate){
      totalOrders
      totalUsers
      totalSales
      orders{
        day
        count
        amount
      }
    }
  }`

export const getQorConfig = `query QorConfig{
  qorConfig{
    _id
    enabled
    sandbox
    platformCommissionRate
    deliveryCommissionRate
    selfDeliveryCommissionRate
    pickupCommissionRate
    flatFee
    platformKeepsTax
  }
}`

export const getQorMerchantKyc = `query QorMerchantKyc($restaurantId:ID!){
  qorMerchantKyc(restaurantId:$restaurantId){
    restaurantId
    name
    qorEntityType
    qorLegalName
    qorDescriptor
    qorEinLast4
    qorEinSet
    qorMcc
    qorBusinessStartDate
    qorBusinessPhone
    qorBusinessEmail
    qorBusinessAddress1
    qorBusinessAddress2
    qorBusinessCity
    qorBusinessState
    qorBusinessZip
    qorBusinessCountry
    qorTimezone
    qorWebsite
    qorAnnualCcSales
    qorAvgTicket
    qorHighTicket
    qorOwners
    qorBankAccountLast4
    qorBankRoutingNumber
    qorBankAccountMethod
    qorBankSet
    qorTcAccepted
    qorKycStatus
    qorMerchantId
    qorMid
    qorBoardingStatus
    qorBoardingStatusLabel
  }
}`

export const getStripeRestaurantAccounts = `query StripeRestaurantAccounts{
  stripeRestaurantAccounts{
    restaurantId
    restaurantName
    accountId
    detailsSubmitted
    transfersActive
    payoutsEnabled
    pendingOrders
    pendingAmount
    dashboardEnabled
    processingFeePercentOverride
    processingFeeFixedOverride
    processingFeePercent
    processingFeeFixed
  }
}`

// Global switch for the Stripe section of restaurant dashboards, read on the
// Stripe Restaurants page next to the per-restaurant switches.
export const getStripeRestaurantDashboardGlobal = `query StripeRestaurantDashboardGlobal{
  configuration{
    _id
    stripeRestaurantDashboard
  }
}`

// The restaurant settings that decide which vendor sidebar links show.
export const getSidebarRestaurantFlags = `query SidebarRestaurantFlags($id:String){
  restaurant(id:$id){
    _id
    selfDelivery
    isMobile
  }
}`

export const getStripeRestaurantDashboard = `query StripeRestaurantDashboard($restaurantId:ID!,$refresh:Boolean){
  stripeRestaurantDashboard(restaurantId:$restaurantId,refresh:$refresh){
    restaurantId
    enabled
    globalEnabled
    restaurantEnabled
    accountId
    detailsSubmitted
    transfersActive
    payoutsEnabled
    pendingOrders
    pendingAmount
    processingFeePercent
    processingFeeFixed
    setupChecklist{
      key
      status
    }
  }
}`

export const getStripeAccountRemovalCheck = `query StripeAccountRemovalCheck($restaurantId:ID!){
  stripeAccountRemovalCheck(restaurantId:$restaurantId){
    accountId
    canRemove
    blockers{
      code
      message
      amount
    }
  }
}`

export const getStripeRestaurantOverview = `query StripeRestaurantOverview($restaurantId:ID!){
  stripeRestaurantOverview(restaurantId:$restaurantId){
    currency
    availableBalance
    pendingBalance
    nextPayout{
      amount
      date
      status
      estimated
      bankLast4
      bankName
    }
    payoutSchedule
    weekVolume
    weekOrders
    weekDaily
    weekDays
  }
}`

export const getStripeRestaurantTransactions = `query StripeRestaurantTransactions($restaurantId:ID!,$refundedOnly:Boolean,$limit:Int,$offset:Int){
  stripeRestaurantTransactions(restaurantId:$restaurantId,refundedOnly:$refundedOnly,limit:$limit,offset:$offset){
    count
    rows{
      orderId
      orderNumber
      createdAt
      scenario
      commissionRate
      customerTotal
      subtotal
      deliveryFee
      deliveryTip
      tax
      serviceFee
      walletCredit
      commissionAmount
      restaurantShare
      processingFee
      processingFeePercent
      processingFeeFixed
      restaurantBreakdown{
        subtotalShare
        processingFee
        tax
        deliveryFee
        deliveryTip
        other
        coveredByPlatform
        storeCredit
      }
      rushmyfoodBreakdown{
        commission
        flatFee
        processingFee
        tax
        deliveryFee
        deliveryTip
        walletCredit
        coveredForRestaurant
      }
      debtRecovered
      withheldFor{
        amount
        orderNumber
        reason
      }
      sentToRestaurant
      status
      transferredAt
      refundedAmount
      takenBack
      refundable
      disputeStatus
    }
  }
}`

export const getStripeRefundPreview = `query StripeRefundPreview($orderId:ID!,$amount:Float){
  stripeRefundPreview(orderId:$orderId,amount:$amount){
    refund
    takenBack
    addedToOwed
    refundable
  }
}`

export const getStripeSplits = `query StripeSplits($restaurantId:ID,$settlementStatus:String,$limit:Int,$offset:Int){
  stripeSplits(restaurantId:$restaurantId,settlementStatus:$settlementStatus,limit:$limit,offset:$offset){
    count
    rows{
      _id
      orderId
      orderNumber
      restaurantId
      restaurantName
      createdAt
      scenario
      settlementStatus
      paymentStatus
      grandTotal
      subtotal
      deliveryFee
      deliveryTip
      tax
      walletCredit
      platformBreakdown{commission flatFee processingFee tax deliveryFee deliveryTip walletCredit coveredForRestaurant}
      restaurantBreakdown{subtotalShare processingFee tax deliveryFee deliveryTip flatFee other coveredByPlatform storeCredit}
      serviceFee
      commissionRate
      commissionAmount
      platformCut
      restaurantCut
      debtRecovered
      refundedAmount
      reversedAmount
      processorFee
      processingFee
      processingFeePercent
      processingFeeFixed
      transferId
      transferredAt
      disputeId
      disputeStatus
    }
  }
}`

export const getQorTransactions = `query QorTransactions($restaurantId:ID,$settlementStatus:String,$includeRecurring:Boolean,$limit:Int,$offset:Int){
  qorTransactions(restaurantId:$restaurantId,settlementStatus:$settlementStatus,includeRecurring:$includeRecurring,limit:$limit,offset:$offset){
    count
    rows{
      _id
      orderId
      orderNumber
      restaurantId
      restaurantName
      qorTransactionId
      scenario
      paymentMethod paymentLabel cardBrand cardLast4
      grandTotal
      cardBrand
      settlementStatus
      paymentStatus
      createdAt
      source
      subtotal
      deliveryFee
      deliveryTip
      tax
      flatFee
      commissionRate
      commissionAmount
      platformCut
      restaurantCut
      platformBreakdown{commission flatFee tax deliveryFee deliveryTip}
      restaurantBreakdown{subtotalShare tax deliveryFee deliveryTip storeCredit}
      debtRecovered
      fallbackDebt
    }
  }
}`

export const getQorRestaurantDebts = `query QorRestaurantDebts($restaurantId:ID,$limit:Int,$offset:Int){
  qorRestaurantDebts(restaurantId:$restaurantId,limit:$limit,offset:$offset){
    count
    rows{
      _id
      restaurantId
      restaurantName
      kind
      amount
      debtId
      orderId
      orderNumber
      reason
      note
      createdAt
    }
    outstanding{
      restaurantId
      restaurantName
      outstanding
    }
  }
}`

export const getQorApiLogs = `query QorApiLogs($direction:String,$path:String,$limit:Int,$offset:Int){
  qorApiLogs(direction:$direction,path:$path,limit:$limit,offset:$offset){
    count
    rows{
      _id
      direction
      method
      path
      httpStatus
      gwCode
      status
      ok
      event
      requestBody
      responseBody
      error
      createdAt
    }
  }
}`

export const getQorRecurringCharges = `query QorRecurringCharges($userId:ID,$kind:String,$limit:Int,$offset:Int){
  qorRecurringCharges(userId:$userId,kind:$kind,limit:$limit,offset:$offset){
    count
    rows{
      _id
      subscriptionId
      userId
      userName
      userEmail
      qorTransactionId
      qorRecurringTxnId
      amount
      kind
      result
      code
      message
      createdAt
    }
  }
}`

export const getConfiguration = `query GetConfiguration{
    configuration{
      _id
      email
      emailName
      enableEmail
      clientId
      sandbox
      publishableKey
      stripeRestaurantDashboard
      stripeProcessingFeePercent
      stripeProcessingFeeFixed
      qorPaymentsEnabled
      stripePaymentsEnabled
      currency
      currencySymbol
      deliveryRate
      nearbyRadiusMiles
      pickupRadiusMiles
      serverTipShare
      twilioPhoneNumber
      twilioEnabled
      formEmail
      sendGridEnabled
      sendGridEmail
      sendGridEmailName
      dashboardSentryUrl
      webSentryUrl
      apiSentryUrl
      customerAppSentryUrl
      restaurantAppSentryUrl
      restaurantAppLatestVersion
      restaurantAppDownloadUrl
      riderAppSentryUrl
      googleApiKey
      mapboxToken
      cloudinaryUploadUrl
      cloudinaryApiKey
      webAmplitudeApiKey
      appAmplitudeApiKey
      webClientID
      androidClientID
      iOSClientID
      expoClientID
     
      googleMapLibraries
      googleColor    
      termsAndConditions
      privacyPolicy
      testOtp
      firebaseKey
      authDomain
      projectId
      storageBucket
      msgSenderId
      appId
      measurementId
      isPaidVersion
      skipEmailVerification
      skipMobileVerification
      costType
      vapidKey
      nmiTokenizationKey
    }
  }`

export const orderCount = `
query OrderCount($restaurant:ID){
  orderCount(restaurant:$restaurant)
}`

export const getActiveOrders = `query GetActiveOrders($restaurantId:ID){
  getActiveOrders(restaurantId:$restaurantId){
    _id
    orderId
    restaurant{
      _id timezone
      name
      image
      address
      location{coordinates}
      deliveryTime
      preparationTime
      zone{
        _id
      }
    }
    deliveryAddress{
      latitude
      longitude
      deliveryAddress
      details
      label
      apartment
      buildingName
      entryCode
      dropoffOption
    }
    items{
      _id
      title
      description
      image
      quantity
      variation{
        _id
        title
        price
        discounted
      }
      addons{
        _id
        options{
          _id
          title
          price
          quantity
          addons{ title additionalCost options{ title price quantity } }
        }
        description
        title
        additionalCost
        quantityMinimum
        quantityMaximum
      }
      specialInstructions
      isActive
    }
    user{
      _id
      name
      phone
      email
    }
    paymentMethod paymentLabel cardBrand cardLast4
    paidAmount
    orderAmount
    orderStatus
    preparedAt
    isPickedUp
    orderType
    orderSource
    isSelfDelivery
    isCatering
    deliveryProofImage
    pickupReceiptImage
    paymentStatus
    reason
    isActive
    createdAt
    deliveryCharges
    serviceFee
    tipping
    taxationAmount
    expectedTime
    preparationTime
    firstDeliveryOrderId
    fdDriverName
    fdDriverPhone
    fdDriverPhoto
    fdDriverTransport
    fdPickupEta
    fdDropoffEta
    fdDropoffPhoto
    fdTrackerLink
    fdDspTrackerLink
    supportTicketId
    supportTicketStatus
    refundedItems
    refundedAmount
    totalRefunded
    rider{
      _id
      name
      username
      phone
      pictureUrl
      driverType
      available
      location { coordinates }
      zone { _id title }
    }
    promotion {
      _id
      code
      discountAmount
    }
    serverTip
    driverTip
    acceptedAt
    assignedAt
    pickedAt
    deliveredAt
    cancelledAt
    assignedStaff {
      _id
      firstName
      lastName
      role
    }
  }
}`

export const getScheduledOrders = `query GetScheduledOrders($restaurantId:ID){
  getScheduledOrders(restaurantId:$restaurantId){
    _id
    orderId
    orderType
    orderSource
    restaurant{ _id timezone name image address location{coordinates} zone{ _id } }
    deliveryAddress{ latitude longitude deliveryAddress details label apartment buildingName entryCode dropoffOption }
    items{
      _id title description image quantity
      variation{ _id title price discounted }
      addons{ _id title description additionalCost quantityMinimum quantityMaximum options{ _id title price addons{ title additionalCost options{ title price quantity } } } }
      specialInstructions isActive
    }
    user{ _id name phone email }
    paymentMethod paymentLabel cardBrand cardLast4 paidAmount orderAmount orderStatus preparedAt isPickedUp isSelfDelivery isCatering deliveryProofImage pickupReceiptImage paymentStatus
    reason isActive orderDate createdAt deliveryCharges serviceFee tipping taxationAmount
    firstDeliveryOrderId fdDriverName fdDriverPhone fdDriverPhoto fdDriverTransport fdPickupEta fdDropoffEta fdDropoffPhoto fdTrackerLink fdDspTrackerLink
    supportTicketId supportTicketStatus refundedItems refundedAmount totalRefunded
    rider{ _id name username phone pictureUrl driverType available }
    promotion { _id code discountAmount }
    serverTip driverTip
    assignedStaff { _id firstName lastName role }
  }
}`

export const getActiveOrdersWithPagination = `query getActiveOrdersWithPagination( $page: Int, $rowsPerPage: Int, $search: String, $restaurantId: ID){
  getActiveOrdersWithPagination( page: $page, rowsPerPage: $rowsPerPage, search: $search, restaurantId: $restaurantId)
 {
   orders
   {
    _id
    orderId
    restaurant{
      _id timezone
      name
      image
      address
      phone
      location{coordinates}
      deliveryTime
      preparationTime
      zone{
        _id
      }
    }
    deliveryAddress{
      latitude
      longitude
      deliveryAddress
      details
      label
      apartment
      buildingName
      entryCode
      dropoffOption
    }
    user{
      _id
      name
      phone
      email
    }
    paymentMethod paymentLabel cardBrand cardLast4
    paidAmount
    orderAmount
    orderStatus
    preparedAt
    isPickedUp
    isSelfDelivery
    deliveryProofImage
    pickupReceiptImage
    paymentStatus
    reason
    isActive
    createdAt
    deliveryCharges
    tipping
    taxationAmount
    expectedTime
    preparationTime
    firstDeliveryOrderId
    fdDriverName
    fdDriverPhone
    fdDriverPhoto
    fdDriverTransport
    fdPickupEta
    fdDropoffEta
    fdDropoffPhoto
    fdTrackerLink
    fdDspTrackerLink
    refundedAmount
    acceptedAt
    assignedAt
    enRoutePickupAt
    arrivedPickupAt
    pickedAt
    enRouteDropoffAt
    arrivedDropoffAt
    deliveredAt
    cancelledAt
    orderType
    orderSource
    manualDeliveryFee
    posCustomerName
    posCustomerPhone
    rider{
      _id
      name
      username
      phone
      pictureUrl
      driverType
      available
      location { coordinates }
      zone { _id title }
    }
    promotion {
      _id
      code
      discountAmount
    }
    serverTip
    driverTip
   }
    totalCount
  }
}`

export const getActiveOrdersStatusCounts = `query getActiveOrdersStatusCounts($restaurantId: ID){
  getActiveOrdersWithPagination(page: 1, rowsPerPage: 1000, restaurantId: $restaurantId){
    orders { _id orderStatus }
    totalCount
  }
}`

// Tab totals for Dispatch, from one grouped COUNT on the server — so the
// screen no longer downloads every order ever placed just to count them.
export const getDispatchOrderCounts = `query DispatchOrderCounts{
  dispatchOrderCounts{
    active pending accepted prepared assigned inTransit delivered cancelled all
  }
}`

// An order's lines, fetched when a Dispatch row is opened. Kept out of the list
// queries because the table never shows them and they are the heaviest part of
// an order.
export const getDispatchOrderItems = `query DispatchOrderItems($id:ID!){
  order(id:$id){
    _id
    items{
      _id title image quantity
      variation{ _id title price discounted }
      addons{ _id title additionalCost options{ _id title price quantity addons{ title additionalCost options{ title price quantity } } } }
      specialInstructions
    }
  }
}`

export const getDispatchAllOrders = `query getDispatchAllOrders($page: Int, $rows: Int){
  getOrdersByVendor(page: $page, rows: $rows){
    _id
    orderId
    restaurant{ _id timezone name image address phone location{coordinates} deliveryTime preparationTime zone{ _id } }
    deliveryAddress{ latitude longitude deliveryAddress details label apartment buildingName entryCode dropoffOption }
    user{ _id name phone email }
    paymentMethod paymentLabel cardBrand cardLast4 paidAmount orderAmount orderStatus paymentStatus
    preparedAt isPickedUp isSelfDelivery deliveryProofImage pickupReceiptImage
    isActive createdAt deliveryCharges tipping taxationAmount
    expectedTime preparationTime
    firstDeliveryOrderId fdDriverName fdDriverPhone fdDriverPhoto fdDriverTransport
    fdPickupEta fdDropoffEta fdDropoffPhoto fdTrackerLink fdDspTrackerLink
    refundedAmount acceptedAt assignedAt enRoutePickupAt arrivedPickupAt pickedAt enRouteDropoffAt arrivedDropoffAt deliveredAt cancelledAt
    orderType orderSource manualDeliveryFee posCustomerName posCustomerPhone
    rider{ _id name phone pictureUrl driverType available location { coordinates } zone { _id title } }
    promotion { _id code discountAmount }
    serverTip driverTip
  }
}`

// A restaurant's own Dispatch board: the same fields, one restaurant's orders.
// ordersByRestId counts pages from 1.
export const getDispatchRestaurantOrders = `query getDispatchRestaurantOrders($restaurant: ID!, $page: Int, $rows: Int){
  ordersByRestId(restaurant: $restaurant, page: $page, rows: $rows){
    _id
    orderId
    restaurant{ _id timezone name image address phone location{coordinates} deliveryTime preparationTime zone{ _id } }
    deliveryAddress{ latitude longitude deliveryAddress details label apartment buildingName entryCode dropoffOption }
    user{ _id name phone email }
    paymentMethod paymentLabel cardBrand cardLast4 paidAmount orderAmount orderStatus paymentStatus
    preparedAt isPickedUp isSelfDelivery dispatchTier deliveryProofImage pickupReceiptImage
    isActive createdAt deliveryCharges tipping taxationAmount
    expectedTime preparationTime
    firstDeliveryOrderId fdDriverName fdDriverPhone fdDriverPhoto fdDriverTransport
    fdPickupEta fdDropoffEta fdDropoffPhoto fdTrackerLink fdDspTrackerLink
    refundedAmount acceptedAt assignedAt enRoutePickupAt arrivedPickupAt pickedAt enRouteDropoffAt arrivedDropoffAt deliveredAt cancelledAt
    orderType orderSource manualDeliveryFee posCustomerName posCustomerPhone
    rider{ _id name phone pictureUrl driverType available location { coordinates } zone { _id title } }
    promotion { _id code discountAmount }
    serverTip driverTip
  }
}`

export const getRestaurantDispatchOrderCounts = `query RestaurantDispatchOrderCounts($restaurantId: ID!){
  dispatchOrderCounts(restaurantId: $restaurantId){
    active pending accepted prepared assigned inTransit delivered cancelled all
  }
}`

// A restaurant's own Dispatch board offers that restaurant's drivers only.
export const getDispatchRestaurantDrivers = `query DispatchRestaurantDrivers($restaurantId: ID){
  restaurantDrivers(restaurantId: $restaurantId){
    _id
    name
    phone
    available
    isActive
    driverType
    restaurantId
    location{ coordinates }
  }
}`

export const getRidersByZone = `query RidersByZone($id:ID!){
  ridersByZone(id:$id){
    _id
    name
    username
    password
    phone
    available
    isActive
    zone{
      _id
      title
    }
  }
}`

// Dispatch's driver picker: same riders as ridersByZone, plus where they are
// and whose staff they are, so it can sort by distance and keep a restaurant's
// own drivers with its own orders.
export const getDispatchRidersByZone = `query DispatchRidersByZone($id:ID!){
  ridersByZone(id:$id){
    _id
    name
    phone
    available
    isActive
    driverType
    restaurantId
    location{ coordinates }
  }
}`

export const getZones = `query Zones{
    zones{
    _id
    title
    description
    location{coordinates}
    isActive
    }
}`

export const getVendors = `query Vendors{
    vendors{
      _id
      name
      email
      userType
      isEmailVerified
      restaurants{
        _id
        orderId
        orderPrefix
        slug
        name
        image
        address
        location{coordinates}
        zone{
          _id
          title
        }
        shopType
      }
    }
}`

export const getVendor = `query GetVendor($id:ID!){
    getVendor(id:$id){
        _id
        name
        phone
        email
        userType
        isActive
        restaurants{
          _id
          orderId
          orderPrefix
          slug
          name
          image
          address
          location{coordinates}
          shopType
        }
    }
}`

export const getTaxation = `query Taxes{
    taxes {
      _id
      taxationCharges
      enabled
      }
    }`

export const getCoupons = `
  query Coupons($page: Int, $rowsPerPage: Int, $search: String) {
    coupons(page: $page, rowsPerPage: $rowsPerPage, search: $search) {
      coupons {
        _id
        title
        discount
        enabled
      }
        totalCount
    }
    }
  `
export const getCuisines = `query Cuisines{
    cuisines {
      _id
      name
      description
      image
      shopType
    }
  }`

export const getBanners = `query Banners{
    banners {
      _id
      title
      description
      action
      screen
      file
      parameters
    }
  }`
export const getBannerActions = `query BannerActions{
    bannerActions
  }`

export const getTipping = `query Tips{
    tips {
      _id
      tipVariations
      enabled
    }
  }`

export const getAddons = `query Addons{
    addons{
    _id
    title
    description
    options{
      _id
      title
      description
      price
    }
    quantityMinimum
    quantityMaximum
  }}`

export const getOptions = `query Options{
    options {
      _id
      title
      description
      price
    }
  }
  `
export const getPaymentStatuses = `query{
    getPaymentStatuses
  }`

export const restaurantByOwner = `query RestaurantByOwner($id:String){
  restaurantByOwner(id:$id){
  _id
  email
  userType
  restaurants{
    _id
    orderId
    orderPrefix
    name
    slug
    image
    address
    username
    password
    location{coordinates}
    shopType
    }
  }
}`

export const restaurantList = `query RestaurantList{
  restaurantList{
    _id
    name
    address
    latitude
    longitude
    selfDelivery
    selfDeliveryMode
    selfDeliveryFromMinute
    selfDeliveryStartsAt
    deliveryFeeMode
    isMobile
    mobileDeliveryEnabled
    mobileDeliveryRadiusMiles
  }
}`

export const restaurants = `query Restaurants{
  restaurants{
    _id
    name
    image
    orderPrefix
    slug
    address
    deliveryTime
    minimumOrder
    isActive
    commissionRate
    deliveryCommissionRate
    selfDeliveryCommissionRate
    pickupCommissionRate
    platformKeepsTax
    serviceFeeOverride
    thirdPartyPercent
    tax
    owner{
      _id
      email
    }
    shopType
  }
}
`

export const restaurantReadiness = `query RestaurantReadiness{
  restaurantReadiness{
    _id
    name
    slug
    image
    logo
    address
    shopType
    selfDelivery
    isActive
    hasLocation
    hasMenu
    hasDeliveryZone
    hasSelfDeliveryZone
    hasOpeningHours
    hasCommission
    firstDeliveryMerchantId
    hasFirstDeliveryMerchantId
    visibleOnWeb
  }
}
`

export const getRestaurantProfile = `query Restaurant($id:String){
      restaurant(id:$id)
      {
      _id
      orderId
      orderPrefix
      slug
      name
      image
      logo
      address
      location{coordinates}
      deliveryBounds{
        coordinates
      }
      username
      password
      phone
      deliveryTime
      minimumOrder
      tax
      isAvailable
      stripeDetailsSubmitted
      openingTimes{
        day
        times{
          startTime
          endTime
        }
      }
      owner{
        _id
        email
      }
      shopType
      cuisines
      enableDelivery
      enablePickup
      enablePickupCOD
      firstDeliveryMerchantId
      selfDelivery
      selfDeliveryMode
      selfDeliveryFromMinute
      selfDeliveryStartsAt
      selfDeliveryUntil
      selfDeliverySummary
      deliveryFeeMode
      autoAccept
      defaultPrepTime
      dispatchMode
      fallbackToPlatform
      isMobile
      timezone
      mobileDeliveryEnabled
      mobileDeliveryRadiusMiles
      serviceLocation{
        latitude
        longitude
        address
        label
        source
        isOpenNow
        windowLabel
        nextStopLabel
      }
      currentStop{
        _id
        label
        address
        windowLabel
        isCheckedIn
      }
    }
}`

export const getRestaurantDetail = `query Restaurant($id:String){
      restaurant(id:$id){
      _id
      orderId
      orderPrefix
      slug
      name
      image
      address
      location{coordinates}
      deliveryTime
      minimumOrder
      tax
      categories{
        _id
        title
        description
        menuIds
        displayOrder
        isCatering
        foods{
          _id
          title
          description
          variations{
            _id
            title
            price
            discounted
            addons
          }
          image
          isActive
        }
      }
      options{
        _id
        title
        description
        price
      }
      addons{
        _id
        options
        title
        description
        quantityMinimum
        quantityMaximum
      }
      shopType
    }
}`

export const getOffers = `query Offers{
  offers{
    _id
    name
    tag
    restaurants{
      _id
      name
    }
  }
}`

export const getSections = `query Sections{
  sections{
    _id
    name
    enabled
    restaurants{
      _id
      name
    }
  }
}`

export const pageCount = `
query PageCount($restaurant:ID){
  pageCount(restaurant:$restaurant)
}
`
export const getUsers = `query{
    users{
      _id
      name
      email
      phone
      isActive
      erasesAt
      erasedAt
      createdAt
      addresses{
        location{coordinates}
        deliveryAddress
      }
    }
  }`

export const getRiders = `query{
    riders{
      _id
      name
      username
      password
      phone
      available
      driverType
      restaurantId
      restaurantName
      zone{
        _id
        title
      }
    }
  }`

export const getAvailableRiders = `query{
    availableRiders{
      _id
      name
      username
      phone
      available
      zone{
        _id
      }
    }
  }`

export const withdrawRequestQuery = `query GetWithdrawRequests{
      getAllWithdrawRequests{
        _id
        amount
        status
        createdAt
        rider{
          _id
          name
          currentWalletAmount
        }
      }
  }`

export const getVendorEarnings = `query VendorEarnings($restaurant:ID!){
  vendorEarnings(restaurant:$restaurant){
    _id
    restaurantId
    orderId
    orderNumber
    orderAmount
    deliveryCharges
    commissionRate
    commissionAmount
    vendorAmount
    paymentMethod paymentLabel cardBrand cardLast4
    status
    createdAt
  }
}`

export const getVendorBalance = `query VendorBalance($restaurant:ID!){
  vendorBalance(restaurant:$restaurant){
    totalEarnings
    totalCommission
    totalVendorAmount
    pendingBalance
    paidOutAmount
    pendingWithdrawals
  }
}`

export const getVendorBankInfo = `query VendorBankInfo{
  vendorBankInfo{
    bankAccountName
    bankAccountLast4
    hasBankAccount
  }
}`

export const getVendorWithdrawRequests = `query VendorWithdrawRequests($restaurant:ID!){
  vendorWithdrawRequests(restaurant:$restaurant){
    _id
    restaurantId
    restaurantName
    amount
    status
    requestNote
    adminNote
    createdAt
    updatedAt
  }
}`

export const getAllVendorWithdrawRequests = `query AllVendorWithdrawRequests{
  allVendorWithdrawRequests{
    _id
    restaurantId
    restaurantName
    amount
    status
    requestNote
    adminNote
    createdAt
    updatedAt
  }
}`

  export const withdrawRequestQueryWithPagination = `query GetWithdrawRequests($offset:Int, $page: Int, $rowsPerPage: Int, $search: String){
    getAllWithdrawRequests(offset:$offset, $page: Int, $rowsPerPage: Int, $search: String){
        success
        message
        data{
          _id
          requestId
          requestAmount
          requestTime
          rider{
            _id
            name
            currentWalletAmount
          }
          status
        }
        pagination{
          total
        }
    }
}`
export const getPromotions = `
  query GetPromotions($restaurantId: ID, $status: String, $page: Int, $rowsPerPage: Int) {
    promotions(restaurantId: $restaurantId, status: $status, page: $page, rowsPerPage: $rowsPerPage) {
      promotions {
        _id
        restaurantId
        name
        internalCode
        description
        promotionType
        status
        triggerType
        couponCode
        targeting
        channel
        isCatering
        isStackable
        priority
        maxRedemptions
        maxPerCustomer
        maxDiscountAmount
        startAtUtc
        endAtUtc
        dayOfWeek
        timeWindowStart
        timeWindowEnd
        conditions { _id conditionType params }
        rewards { _id rewardType params }
        analytics { eligibleCarts appliedCount discountTotal revenueTotal }
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`

export const getPromotion = `
  query GetPromotion($id: ID!) {
    promotion(id: $id) {
      _id
      restaurantId
      name
      internalCode
      description
      promotionType
      status
      triggerType
      couponCode
      targeting
      channel
      isCatering
      isStackable
      priority
      maxRedemptions
      maxPerCustomer
      maxDiscountAmount
      startAtUtc
      endAtUtc
      dayOfWeek
      timeWindowStart
      timeWindowEnd
      stopIds
      conditions { _id conditionType params }
      rewards { _id rewardType params }
      analytics { eligibleCarts appliedCount discountTotal revenueTotal }
      createdAt
      updatedAt
    }
  }
`

export const previewPromotion = `
  query PreviewPromotion($promotionId: ID!, $cartInput: CartEvaluationInput!) {
    previewPromotion(promotionId: $promotionId, cartInput: $cartInput) {
      appliedPromotion { _id name }
      discountAmount
      discountedDeliveryFee
      originalSubtotal
      discountedSubtotal
      finalTotal
      explanationMessage
      freeItems { foodId title }
    }
  }
`

export const getPromotionAnalytics = `
  query GetPromotionAnalytics($id: ID!) {
    promotionAnalytics(id: $id) {
      eligibleCarts
      appliedCount
      discountTotal
      revenueTotal
    }
  }
`

export const getRestaurantDeliveryZones = `
  query RestaurantDeliveryZones($restaurantId: ID!) {
    restaurantDeliveryZones(restaurantId: $restaurantId) {
      _id
      restaurantId
      name
      fee
      sortOrder
      polygon {
        coordinates
      }
    }
  }
`

export const allRestaurantDeliverySummary = `
  query AllRestaurantDeliverySummary {
    allRestaurantDeliverySummary {
      restaurantId
      zoneCount
      zones {
        _id
        name
        fee
      }
      selfDelivery
      selfDeliveryZoneCount
    }
  }
`

export const vendorSelfDeliveryZones = `
  query VendorSelfDeliveryZones($restaurantId: ID!) {
    vendorSelfDeliveryZones(restaurantId: $restaurantId) {
      _id
      restaurantId
      name
      fee
      sortOrder
      polygon {
        coordinates
      }
    }
  }
`

export const restaurantDistanceBands = `
  query RestaurantDistanceBands($restaurantId: ID!) {
    restaurantDistanceBands(restaurantId: $restaurantId) {
      _id
      restaurantId
      maxMiles
      fee
      sortOrder
    }
  }
`

export const platformDistancePricing = `
  query PlatformDistancePricing {
    platformDistancePricing {
      mode
      bands {
        _id
        maxMiles
        fee
        sortOrder
      }
    }
  }
`

export const loyaltyConfig = `
  query LoyaltyConfig {
    loyaltyConfig {
      pointsPerDollar
      minOrderForRedemption
      couponExpiryDays
      allowStackWithPromo
      annualTierReset
    }
  }
`

export const loyaltyRedemptionTiersAdmin = `
  query LoyaltyRedemptionTiersAdmin {
    loyaltyRedemptionTiers {
      _id
      pointsRequired
      couponValue
      isActive
      sortOrder
    }
  }
`

export const loyaltyTierConfig = `
  query LoyaltyTierConfig {
    loyaltyTierConfig {
      _id
      tierName
      tierKey
      minLifetimePoints
      maxLifetimePoints
      earningMultiplier
      sortOrder
    }
  }
`

export const loyaltyCampaigns = `
  query LoyaltyCampaigns {
    loyaltyCampaigns {
      _id
      name
      multiplier
      startsAt
      endsAt
      isActive
    }
  }
`

export const loyaltyAnalytics = `
  query LoyaltyAnalytics {
    loyaltyAnalytics {
      totalPointsIssued
      totalPointsRedeemed
      totalCouponValueIssued
      activeCouponsCount
      topCustomers {
        userId
        name
        email
        lifetimePoints
        tier
      }
    }
  }
`

export const adminGetUserLoyalty = `
  query AdminGetUserLoyalty($userId: ID!) {
    adminGetUserLoyalty(userId: $userId) {
      balance
      lifetimePoints
      tier
      transactions {
        _id
        type
        points
        status
        description
        createdAt
      }
    }
  }
`


export const blackCardProgram = `
  query BlackCardProgram {
    blackCardProgram {
      enabled
      monthlyPrice
      deliveryDiscountCap
      bonusPointsPerOrder
      updatedAt
    }
  }
`

export const adminBlackCardSubscribers = `
  query AdminBlackCardSubscribers {
    adminBlackCardSubscribers {
      _id
      userId
      userName
      userEmail
      processor
      monthlyPrice
      status
      currentPeriodEnd
      cancelledAt
      createdAt
    }
  }
`

// ── Staff Management ──────────────────────────────────────────────────────────

export const getRestaurantStaff = `
  query RestaurantStaff($restaurantId: ID) {
    restaurantStaff(restaurantId: $restaurantId) {
      _id
      firstName
      lastName
      email
      phone
      address
      role
      isActive
      emailVerified
      phoneVerified
      totalTipsEarned
      totalTipsPaid
      createdAt
      restaurant {
        _id timezone
        name
        address
      }
    }
  }
`

export const getInactiveRestaurantStaff = `
  query InactiveRestaurantStaff($restaurantId: ID) {
    inactiveRestaurantStaff(restaurantId: $restaurantId) {
      _id
      firstName
      lastName
      email
      phone
      address
      role
      isActive
      emailVerified
      phoneVerified
      createdAt
      updatedAt
    }
  }
`

export const getRestaurantDrivers = `
  query RestaurantDrivers($restaurantId: ID) {
    restaurantDrivers(restaurantId: $restaurantId) {
      _id
      name
      username
      phone
      available
      isActive
      driverType
      restaurantId
      zone {
        _id
        title
      }
      createdAt
    }
  }
`

export const getOnDutyStaff = `
  query OnDutyStaff {
    onDutyStaff {
      onDutyStaff {
        _id
        firstName
        lastName
        role
      }
    }
  }
`

export const getStaffPayouts = `
  query StaffPayouts($staffId: ID!, $restaurantId: ID) {
    staffPayouts(staffId: $staffId, restaurantId: $restaurantId) {
      _id
      staffId
      amount
      method
      note
      recordedBy
      paidAt
      createdAt
    }
  }
`

export const getStaffMember = `
  query StaffMember($id: ID!) {
    staffMember(id: $id) {
      _id
      firstName
      lastName
      role
      totalTipsEarned
      totalTipsPaid
    }
  }
`

export const riderById = `query Rider($id: ID!) {
  rider(id: $id) {
    _id
    name
    phone
    pictureUrl
    driverType
    location { coordinates }
  }
}`


// ── Food trucks ─────────────────────────────────────────────────────────────
// A truck's schedule of stops. WEEKLY and MONTHLY rows repeat and are always
// returned; ONE_OFF rows are bounded by from/to. truckId narrows it to one truck.
export const restaurantStops = `query RestaurantStops($restaurantId:ID,$from:String,$to:String,$includePast:Boolean,$truckId:ID){
  restaurantStops(restaurantId:$restaurantId,from:$from,to:$to,includePast:$includePast,truckId:$truckId){
    _id
    truckId
    label
    address
    imageUrl
    latitude
    longitude
    isCheckedIn
    recurrence
    stopDate
    dayOfWeek
    weekOfMonth
    scheduleLabel
    hasOwnMenu
    stockMode
    recurrenceStartDate
    recurrenceEndDate
    exceptionDates
    startMinute
    endMinute
    windowLabel
    status
    isAdHoc
    notes
    isPaused
    pausedUntil
    pauseReason
  }
}`

// Where the restaurant is serving from right now (today's stop, for a truck).
export const restaurantServiceLocation = `query RestaurantServiceLocation($restaurantId:ID){
  restaurantServiceLocation(restaurantId:$restaurantId){
    latitude
    longitude
    address
    label
    source
    isOpenNow
    windowLabel
    nextStopLabel
  }
}`

// The trucks under one food-truck restaurant (migration 145). A truck
// restaurant always has at least one ("Truck 1").
export const restaurantTrucks = `query RestaurantTrucks($restaurantId:ID){
  restaurantTrucks(restaurantId:$restaurantId){
    _id
    restaurantId
    name
    displayOrder
    isActive
  }
}`

// Delivery Boundaries for a food truck: each truck's stops today and the radius
// it delivers around each one.
export const truckDeliveryToday = `query TruckDeliveryToday($restaurantId:ID!){
  truckDeliveryToday(restaurantId:$restaurantId){
    restaurantId
    date
    dateLabel
    deliveryEnabled
    radiusMiles
    trucks{
      truckId
      name
      nextLabel
      stops{
        status
        stop{
          _id
          label
          address
          latitude
          longitude
          windowLabel
        }
      }
    }
  }
}`

// The "Menu at this stop" editor: every item on the regular menus, whether the
// stop sells it, its stop-only price and its on-hand count.
export const stopMenu = `query StopMenu($stopId:ID!){
  stopMenu(stopId:$stopId){
    stopId
    useFullMenu
    stockMode
    items{
      itemId
      name
      categoryName
      imageUrl
      pricingMode
      regularPrice
      regularVariantPrices
      included
      stopPrice
      stopVariantPrices
      stockQuantity
      stockLeft
    }
  }
}`

// Egress monitor (backend utils/egressMonitor.js) — where Railway-billed bytes come from.
export const getEgressReport = `query EgressReport($hours:Int){
  egressReport(hours:$hours){
    enabled
    hours
    since
    generatedAt
    firstTrackedAt
    trackedSeconds
    processStarts
    dbEndpoint
    dbPublic
    pricePerGb
    streams{ stream billed bytesOut bytesIn billedBytes connections }
    series{ hour stream bytes }
    rows{ layer key sub bytesOut bytesIn count extra }
    layerTotals{ layer bytesOut bytesIn count }
    mysql{
      uptimeSeconds
      bytesSentSinceStart
      ownHost
      note
      clients{ host user db connections busy isThisBackend }
      digests{ digest calls rowsSent rowsExamined seconds }
    }
  }
}`

export const getEgressBreakdown = `query EgressBreakdown($layer:String!,$key:String,$sub:String,$hours:Int){
  egressBreakdown(layer:$layer,key:$key,sub:$sub,hours:$hours){ layer key sub bytesOut bytesIn count extra }
}`

/* ── Super admin dashboard. All money fields are integer CENTS. ───────── */
const SA_TOTALS = `orders cancelled grandTotal netRevenue aov itemSubtotal discounts discountsPlatform discountsRestaurant
  deliveryFees serviceFees tax tips driverTips commission commissionRate platformDeliveryFees payoutOwed refunds refundsPlatform
  processingFees driverPayouts ordersWithSplit ordersWithProcessingFee deliveryOrders deliveryOrdersWithPayout refundedOrders`

export const superAdminDashboard = `query SuperAdminDashboard($filter: SaFilterInput, $refresh: Boolean){
    superAdminDashboard(filter: $filter, refresh: $refresh){
      preset compare channel fulfillment from to prevFrom prevTo granularity timezone financialsTracked generatedAt
      current { ${SA_TOTALS} }
      previous { ${SA_TOTALS} }
      series { date gmv netRevenue commission orders aov }
      prevSeries { date gmv netRevenue commission orders aov }
      waterfall { restaurantPayouts driverPayouts taxRemitted processingFees platformNet noSplit }
      mix {
        fulfillment { key label count share gmv }
        channel { key label count share gmv }
        payment { key label count share gmv }
      }
      reconciliation { ok count orders { id orderId restaurantId computed recorded } }
    }
  }`

export const superAdminLeaderboard = `query SuperAdminLeaderboard($filter: SaFilterInput, $refresh: Boolean){
    superAdminLeaderboard(filter: $filter, refresh: $refresh){
      generatedAt
      rows { restaurantId name slug isActive orders itemSubtotal discounts deliveryFees tips tax grandTotal commissionRate commission refunds payoutOwed prevGrandTotal share }
      totals { orders itemSubtotal discounts deliveryFees tips tax grandTotal commissionRate commission refunds payoutOwed prevGrandTotal }
    }
  }`

export const superAdminOperations = `query SuperAdminOperations($filter: SaFilterInput, $refresh: Boolean){
    superAdminOperations(filter: $filter, refresh: $refresh){
      generatedAt
      drivers { availableNow totalRiders ridersDelivering deliveriesCompleted avgTipPerDelivery driverPayouts deliveryOrdersWithPayout deliveryOrders pendingPayoutRequests }
      health { cancellationRate refundRate avgDeliveryMinutes stuckPending { id orderId restaurantId restaurantName minutes } }
      platform { restaurantsActive restaurantsInactive newRestaurants vendors customers newCustomers }
      recentOrders { id number restaurantName restaurantTimezone placedAt channel fulfillment itemSubtotal discounts tips commission grandTotal status }
    }
  }`

export const exportSuperAdminCsv = `mutation ExportSuperAdminCsv($filter: SaFilterInput){
    exportSuperAdminCsv(filter: $filter)
  }`

